import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

export const LessonlyIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24" fontSize="large">
        <path
            d="M18,11c0.34,0,0.67,0.03,1,0.08V4c0-1.1-0.9-2-2-2H5C3.9,2,3,2.9,3,4v16c0,1.1,0.9,2,2,2h7.26C11.47,20.87,11,19.49,11,18 C11,14.13,14.13,11,18,11z M7,11V4h5v7L9.5,9.5L7,11z"/><path d="M18,13c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5S20.76,13,18,13z M16.75,20.5v-5l4,2.5L16.75,20.5z"/>
    </SvgIcon>
);
